import * as React from "react";
import { Container, Box, Paper } from "@mui/material";
import Grid from '@mui/material/Grid2';

import CaseStudyCard from 'components/Cards/CaseStudyCard';
import theme from 'utils/theme';

const CaseStudiesFeed = props => {

	const { caseStudies } = props;

	const boxGridStyle = {
        display: "grid",
        gridTemplateColumns: "repeat(12, 1fr)",
        gridAutoRows: "minmax(100px, auto)",
        gridColumnGap: "6px",
        gridRowGap: "6px",
		minHeight: "361px",
		[theme.breakpoints.down('laptop')]: {
			display: "flex",
			flexDirection: "column",
		}
    };

    const baseGridPatterns = [
        [1, 1, 3, 7],
        [1, 7, 3, 10],
        [1, 10, 3, 13],
        [3, 1, 4, 9],
        [3, 9, 5, 13],
        [4, 1, 6, 5],
        [4, 5, 6, 9],
        [5, 9, 6, 13]
    ];

    const getGridArea = (index) => {
        const patternIndex = index % baseGridPatterns.length;
        const cycle = Math.floor(index / baseGridPatterns.length);
        const [rowStart, colStart, rowEnd, colEnd] = baseGridPatterns[patternIndex];
        const rowOffset = cycle * 5; // Moves down each cycle
        return `${rowStart + rowOffset} / ${colStart} / ${rowEnd + rowOffset} / ${colEnd}`;
    };

	return (
		<Container id="case-studies-feed" sx={{ scrollMarginTop: "155px" }}>
			<Grid container spacing={"6px"} justifyContent={'center'}>
				<Grid size={{ xs: 12 }}>
					<Box sx={boxGridStyle}>
						{caseStudies.map((caseStudy, index) => (
							<Paper
								sx={{ gridArea: getGridArea(index) }}
								key={index}
							>
								<CaseStudyCard caseStudy={caseStudy} isTall={index % 4 === 0} />
							</Paper>
						))}
					</Box>
				</Grid>
			</Grid>
		</Container>
	)
}

export default CaseStudiesFeed;